import { gql } from "__generated__";

export const GET_PORTFOLIO_WITHOUT_MEDIA = gql(`
  query ProPortfolioWithoutMedia($handle: String!) {
    proPortfolio(handle: $handle) {
      firstName
      lastName
      phone
      email
      isEmailHidden
      employmentHistory {
        id
        isPinned
        companyName
        jobTitle
        description
        startedAt
        endedAt
        createdAt
        images {
          id
          name
          mimeType
          originalUrl
          thumbnailUrl
          deletedAt
        }
      }
      workHistory {
        id
        name
        description
        startedAt
        endedAt
        images {
          id
          name
          mimeType
          originalUrl
          thumbnailUrl
          deletedAt
        }
        clientReview {
          rating
          feedback
        }
        verified
        isPinned
        createdAt
      }
      backgroundCheckStatus
      identityVerificationStatus
      certifications {
        id
        name
        issuedBy
        issuedAt
        issuerCertificationId
        url
        verified
        createdAt
      }
      educationEntries {
				id
				schoolName
				fieldOfStudy
				qualification
				verified
				createdAt
      }
      title
      location
      averageRating
      averageLaborHackJobsRatings {
        averageAppearanceRating
        averagePunctualityRating
        averagePostServiceCleanUpRating
        averageBehaviorRating
        averageProperToolUsageRating
      }
      ratingCount
      overview
      experience
    }
  }
`);
